import React, { useEffect, useState, useContext } from "react";

const PrivacyPolicypage = () => {
  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      .scroll-container {
        overflow-y: auto;   /* Enables vertical scroll */
        max-height: 100vh;  /* Important */
      }
    `;
    document.head.appendChild(style);
  }, []);
  return (
    <>
       <div className="scroll-container"
        style={{
          padding: "40px 20px",
          margin: "0 auto",
        }}
      >
        <h4 style={{ textAlign: "center", textDecoration: "underline" , paddingBottom:"4px"}}>
          Privacy Policy
        </h4>

        <p>
          <strong>Softmate Systems LLP</strong> ("we," "our," or "us") is
          committed to protecting your privacy. This Privacy Policy explains how
          we collect, use, and safeguard your information when you use our
          Android application <strong>SUP-RDD</strong> ("App").
        </p>

        <h4>1. Information We Collect</h4>

        <p>When you use SUP-RDD, we may collect the following information:</p>

        <h5>Personal Information</h5>
        <ul>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Address</li>
          <li>Designation (for role-based login access)</li>
          <li>Login credentials (username and password)</li>
        </ul>

        <h5>Device & Usage Information</h5>
        <ul>
          <li>Device type and operating system</li>
          <li>IP address</li>
          <li>Log data</li>
          <li>App usage statistics</li>
        </ul>

        <h5>Location Information</h5>
        <ul>
          <li>Precise GPS location (if enabled)</li>
        </ul>
        <p>Used for project/site tracking and verification purposes.</p>

        <h5>Camera & Media Access</h5>
        <ul>
          <li>
            Camera access for capturing and uploading site progress images
          </li>
          <li>Access to device media/storage to upload existing images</li>
        </ul>
        <p>
          We do not access your camera, location, or storage without your
          permission.
        </p>

        <h4>2. How We Use Your Information</h4>
        <ul>
          <li>Provide and maintain the App services</li>
          <li>Capture and upload progress/site images</li>
          <li>Record accurate GPS location for project monitoring</li>
          <li>Improve app performance and functionality</li>
          <li>Send important updates or administrative notifications</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h4>3. Sharing of Information</h4>
        <p>We do not sell or rent your personal data.</p>
        <p>We may share information with:</p>
        <ul>
          <li>
            Authorized Service Providers (for hosting, analytics, technical
            support)
          </li>
          <li>Legal Authorities, if required by law</li>
          <li>Business Transfers, in case of merger or acquisition</li>
        </ul>

        <h4>4. Data Security</h4>
        <p>
          We implement reasonable technical and administrative safeguards to
          protect your data. However, no internet transmission method is
          completely secure.
        </p>

        <h4>5. Data Retention</h4>
        <p>
          We retain personal data only as long as necessary for operational and
          legal purposes.
        </p>

        <h4>6. Your Rights & Choices</h4>
        <ul>
          <li>Access and update your personal information</li>
          <li>Request correction of inaccurate data</li>
          <li>Disable permissions (Camera/Location) from device settings</li>
          <li>Opt out of promotional communications</li>
        </ul>

        <h4>7. Children's Privacy</h4>
        <p>
          SUP-RDD is not intended for individuals under 18 years of age. We do
          not knowingly collect personal information from children.
        </p>

        <h4>8. Changes to This Privacy Policy</h4>
        <p>
          We may update this Privacy Policy periodically. Updates will be posted
          on this page with a revised effective date.
        </p>

        <h4>9. Contact Information</h4>
        <p>
          <strong>Company Name:</strong> Softmate Systems LLP
        </p>
        <p>
          <strong>Email:</strong> softmate.suport@gmail.com
        </p>
      </div>
    </>
  );
};

export default PrivacyPolicypage;
